export default class Articles {
    static init(): void {
        this.handleOpenArticle()
    }

    static handleOpenArticle(): void {
        const articleCards = document.querySelectorAll('.article-card') as NodeListOf<HTMLElement>


    }


}
